import { PromissoryNoteField } from './components/PromissoryNoteField';
import { ApprovedLoanAmountField } from './components/ApprovedLoanAmountField';
import { InterestRateField } from './components/InterestRateField';
import { InterestAccrualField } from './components/InterestAccrualField';
import { ReserveRateField } from './components/ReserveRateField';
import { GradeField } from './components/GradeField';
import { EntireStructureField } from './components/EntireStructureField';
import { LiquidityField } from './components/LiquidityField';
import { ItemRow } from '../../../ItemRow/ItemRow';

/**
 * The Loan step's fields for a Fix-Flip LOC (sub note) loan. Rate and Reserve Rate come from the master note (locked),
 * LOC grades, Entire Structure; no floor/ceiling, fees, or broker amounts.
 */
export const SubNoteFixFlipPanel = () => {
    return (
        <>
            <ItemRow>
                <PromissoryNoteField />
                <ApprovedLoanAmountField />
            </ItemRow>
            <ItemRow>
                <InterestRateField isSubNote={true} />
                <InterestAccrualField />
            </ItemRow>
            <ItemRow>
                <ReserveRateField disabled={true} />
                <GradeField isSubNote={true} />
            </ItemRow>
            <ItemRow>
                <EntireStructureField />
                <LiquidityField />
            </ItemRow>
        </>
    );
};
